import loginAuxiliarControl from '@/mixins/Login/loginAuxiliarControl';
import loginCookiesAndLocaleControl from '@/mixins/Login/loginCookiesAndLocaleControl';
import loginRoutesControl from '@/mixins/Login/loginRoutesControl';
import loginMessageControl from '@/mixins/Login/loginMessageControl';

export default {

	mixins: [
		loginAuxiliarControl,
		loginCookiesAndLocaleControl,
		loginRoutesControl,
		loginMessageControl
	],

	methods: {
		/**
		 * Login
		 **/
		login() {
			this.username = (this.username != null ? this.username.trim() : null);
			this.password = (this.password != null ? this.password.trim() : null);
			this.isSuper = (this.isSuper != null ? this.isSuper : false);

			if(typeof this.$cookie.get("hashlogin") != 'undefined') {
				this.hashlogin = this.$cookie.get("hashlogin");
			}

			this.$helper.openLoader();

			let data = new FormData();
			data.append("class",				"Login");
			data.append("method",				"doLogin");
			data.append("username",				this.username);
			data.append("password",				this.password);
			data.append("remember_computer",	this.rememberComputer);
			data.append("hashlogin",			this.hashlogin);
			data.append("gtoken",				this.tokens);

			if(this.$route.path == "/login_super" || this.$route.path == "/login_first_super"){
				this.isSuper  = true;
				data.append("login_super", 1);
			}

			this.$helper.axios().post('', data)
				.then(
					(response) => {
						this.$helper.closeLoader();

						this.hashlogin = null;
						this.$cookie.remove("hashlogin");

						let urlGToken = null;
						if(response.data.urlGToken){
							urlGToken = response.data.urlGToken;

							if(typeof response.data.language != "undefined"){
								this.$locale.change(response.data.language);
								this.$cookie.set('language', response.data.language, {"SameSite": "None", "Secure": ""});
							}

							this.toEnableTwoFactorAuthentication(urlGToken, this.username, this.password, this.isSuper);
							return;
						}

						if(response.data.needGToken){
							this.needGToken = true;

							this.message(this.$t("message_title_warning"), response.data.msg, "warning");
							return;
						}

						this.setCookiesLoggedIn(response);

						let forcepwd = '';
						if(typeof response.data != 'undefined'){
							if(typeof response.data.forcepwd != 'undefined'){
								forcepwd = response.data.forcepwd;
							}
						}

						if(forcepwd == 'Y'){
							this.$cookie.set('forcepwd', response.data.forcepwd, {"SameSite": "None", "Secure": ""});

							if (this.isSuper) {
								this.toResetPassword(this.$t('login_first_access'), this.$t('login_title'), this.username, this.password, null);
								return;
							}

							this.$helper.pushRouteTo({ name: 'LoginFirst' });
						}else{
							let merchant_number = response.data.merchant_number;
							//Manda para a página, conforme prioridade de acesso
							this.pushRouteToAccessPriority(merchant_number);
						}
					}
				)
				.catch(
					(error) => {
						this.showErrorLogin(error);
					}
				);
		},

		/**
		 * Primeiro acesso
		 **/
		firstLogin() {
			this.username = (typeof this.username != "undefined" && this.username != null ? this.username.trim() : null);
			this.password = (typeof this.password != "undefined" && this.password != null ? this.password.trim() : null);

			this.$helper.openLoader();

			let data = new FormData();
			data.append("class",				"Login");
			data.append("method",				"doLogin");
			data.append("username",				this.username);
			data.append("password",				this.password);
			data.append("remember_computer",	false);
			data.append("hashlogin",			this.hashlogin);
			data.append("gtoken",				this.tokens);

			if(this.isSuper){
				data.append("login_super", 1);
			}

			this.$helper.axios().post('', data)
				.then(
					(response) => {
						this.$helper.closeLoader();

						this.hashlogin = null;
						this.$cookie.remove("hashlogin");

						this.setCookiesLoggedIn(response);

						if(response.data.needGToken){
							this.message(this.$t("message_title_warning"), response.data.msg, "warning");
							return;
						}

						this.toResetPassword(this.$t('login_first_access'), this.$t('login_title'), this.username, this.password, null);
					}
				)
				.catch(
					(error) => {
						this.showErrorLogin(error);
					}
				);
		},

		/**
		 * Resetar senha
		 **/
		resetPassword() {
			this.removeSpace();

			if(this.password != this.password_confirm){
				this.message(this.$t("message_title_error"), this.$t('login_msg_password_same'), "error");
				return false;
			}

			// Se não existir o code_access, é o primeiro acesso, portanto é necessário ter a senha
			if(this.code_access == null && (this.password_temp == null || this.password_temp.trim() == '')){
				this.message(this.$t("message_title_error"), this.$t('login_msg_inform_pass'), "error");
				return false;
			}

			if(this.password == null || this.password.trim() == ''){
				this.message(this.$t("message_title_error"), this.$t('login_msg_inform_new_pass'), "error");
				return false;
			}

			// Se o primeiro ou o último caractere forem espaços em branco, rejeita
			if(this.password.substr(-1) == " " || this.password.substr(0,1) == " "){
				this.message(this.$t("message_title_error"), this.$t('login_msg_space_trim'), "error");
				return false;
			}

			var data = new FormData();

			data.append("class", 			'Login');
			data.append("method", 			'resetPassword');
			data.append("username", 		this.username);
			data.append("password_temp",	this.password_temp);
			data.append("password", 		this.password);
			data.append("password_confirm", this.password_confirm);
			data.append("code_access", 		this.code_access);
			data.append("gtoken",			this.tokens);

			this.$helper.openLoader();

			this.$helper
			.axios().post('', data)
				.then(
					(response) => {
						this.$helper.closeLoader();

						this.setCookiesLoggedIn(response);

						if(response.data.username == this.username){
							this.perm = JSON.parse(localStorage.getItem('perm'));
							//Manda para rota, conforme prioridade de acesso
							this.pushRouteToAccessPriority(this.$cookie.get("xpp"));
						}else{
							this.message(this.$t("message_title_error"), "Error processing request.", "error");
						}
					}
				)
				.catch(
					(error) => {
						this.showErrorLogin(error);
					}
				);
		},

		/**
		 * Esqueci a senha, gerar código por email
		 **/
		forgotPassword() {
			if (this.username == null || this.username == "") {
				this.message(this.$t("message_title_error"), this.$t('login_username_ph'), "error");
				return false;
			}

			this.$helper.openLoader();

			var data = new FormData();
			data.append("class", "Login");
			data.append("method", "forgetPassword");
			data.append("username", this.username);

			this.$helper.axios().post('', data)
				.then(
					(response) => {
						this.$helper.closeLoader();

						this.setCookiesLoggedIn(response);

						if(response.data.send == true){
							let email = response.data.email==''?this.username:response.data.email;
							this.toRecoverConfirmCode(this.username, email);
						}
					}
				)
				.catch(
					(error) => {
						this.showErrorLogin(error);
						return false;
					}
				);
		},

		/**
		 * Valida código de acesso
		 **/
		confirmAccessCode() {
			if (this.username == null || this.username == "") {
				this.message(this.$t("message_title_error"), this.$t('login_msg_invalid_username'), "error");
				return false;
			}

			if (this.codeVerification == null || this.codeVerification == "") {
				this.message(this.$t("message_title_error"), this.$t('login_msg_invalid_access_code'), "error");
				return false;
			}

			this.$helper.openLoader();

			var data = new FormData();
			data.append("class", "Login");
			data.append("method", "checkAccessCode");
			data.append("username", this.username);
			data.append("code_access",	this.codeVerification);

			this.$helper.axios().post('', data)
				.then(
					(response) => {
						this.$helper.closeLoader();

						this.setCookiesLoggedIn(response);

						this.toResetPassword(
							this.$t('login_create_new_password'),
							this.$t('login_create_password_and_access'),
							this.username,
							null,
							this.codeVerification
						);
					}
				)
				.catch(
					(error) => {
						this.showErrorLogin(error);
						return false;
					}
				);
		},
	},
};